module.exports = __webpack_public_path__ + "static/img/nextIcon.01e94c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nextIcon.png
// module id = 005Z
// module chunks = 1